export function getMonth(dateString, month = 'short') {
  let value = '';
  try {
    const monthName = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Africa/Nairobi',
      month
    }).format;
    const date = new Date(dateString);
    value = monthName(date);
  } catch (error) {
    // console.error(`getMonth`, error);
  }
  return value;
}

export function getDate(dateString) {
  let value = '';
  try {
    const date = new Date(dateString);
    value = ('0' + date.getDate()).slice(-2);
  } catch (error) {
    // console.error(`getDate`, error);
  }
  return value;
}

export function getDay(dateString) {
  let value = '';
  try {
    const date = new Date(dateString);
    const dayName = date.toString().split(' ')[0];
    value = dayName;
  } catch (error) {
    // console.error(`getDay`, error);
  }
  return value;
}

export function getHours(dateString) {
  let value = '';
  try {
    const date = new Date(dateString);
    value = date
      .toLocaleString('en-US', {
        timeZone: 'Africa/Nairobi',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      })
      .toLowerCase();
  } catch (error) {
    // console.error(`getHours`, error);
  }
  return value;
}

export function formatDate(date) {
  let value = '';
  try {
    const config = {
      timeZone: 'Africa/Nairobi',
      month: 'short',
      year: 'numeric',
      day: '2-digit'
    };
    value = `${new Date(date).toString().split(' ')[0]}, ${new Date(
      date
    ).toLocaleString('en-US', config)}`;
  } catch (error) {}
  return value;
}

export function formatTime(date) {
  let value = '';
  try {
    const config = {
      timeZone: 'Africa/Nairobi',
      hour: '2-digit',
      minute: '2-digit'
    };
    value = new Date(date).toLocaleString('en-US', config);
  } catch (error) {}
  return value;
}

export function isDateBeforeToday(date) {
  return new Date(date) > new Date();
}

export function isDateAfterToday(date) {
  return new Date(date) < new Date();
}

export function getFullYear(date) {
  let value = '';
  try {
    value = new Date(date).getFullYear();
  } catch (error) {}
  return value;
}

export function convertAddToCalendarDate(date) {
  const formattedDate = new window.Date(date).toISOString();
  const dateWithoutMilliseconds = formattedDate.slice(0, -5) + 'Z';
  return dateWithoutMilliseconds.replace(/[^0-9A-Za-z]/g, '');
}
